import { Button } from '@mui/material';

export const ButtonSendInvitation = ({
  sendIcon,
  handleClickOpen,
  visibility,
  hasWhatsApp,
  label = 'Enviar invitación',
}) => {
  return (
    <Button
      startIcon={sendIcon}
      variant="outlined"
      onClick={handleClickOpen}
      disabled={hasWhatsApp ? hasWhatsApp : !visibility}
      size="small"
    >
      {label}
    </Button>
  );
};
